import isNil from 'lodash/isNil'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import type { Dispatch } from 'react'
import { useState, useEffect } from 'react'
import { jsonTryParse } from '@ztechapps/common.utils'
import { useToast } from '../useToast'
import join from 'lodash/join'
import filter from 'lodash/filter'

export type UseErrorResult = {
  onError: (error: any) => string
  error: string
  setError: Dispatch<string>
  requiredCheck: (value: any, fieldName: string) => void
}
export const useError = (errorObject?: any): UseErrorResult => {
  const [error, setError] = useState<string>(null)

  const { showError } = useToast()
  const onError = (error: any): string => {
    let errorMessage = error.message || error

    const errorObj = jsonTryParse(errorMessage)

    //try to get the validation error from "graphQLErrors"
    const grapqlValidationErrors = error?.graphQLErrors?.[0]?.extensions?.exception?.validationErrors

    const validationError: { field: string; message: string }[] = grapqlValidationErrors ?? errorObj?.[0]?.validationError

    if (validationError) {
      //we nee to remove the duplicate error messages (or the message same with the parent)
      const noDuplicateErrors = filter(validationError, (e) => {
        const currentValidationErrorMessage = e?.message
        return !isEmpty(currentValidationErrorMessage) && currentValidationErrorMessage !== errorMessage
      })

      //update the new value for the error message
      errorMessage =
        `${errorMessage ?? 'Error occured:'} \n` +
        join(
          map(noDuplicateErrors, (e) => `${e?.message} - ${e?.field}`),
          '\n'
        )
    }

    showError({ message: errorMessage })
    setError(errorMessage)
    return errorMessage
  }

  const requiredCheck = (value: any, fieldName: string) => {
    if (isEmpty(value)) {
      throw new Error(`'${fieldName}' field is required to have values. \n\nYou can press "Escape" key to revert back to original value.`)
    }
  }

  //this is a reactive error, now
  useEffect(() => {
    if (!isNil(errorObject)) {
      onError(errorObject)
    }
  }, [errorObject])

  return { onError, error, setError, requiredCheck }
}
